module.exports = __webpack_public_path__ + "ARIALBD.8ca51cf32bd73d7d8bdd.woff";


//////////////////
// WEBPACK FOOTER
// G:/UTL/BMI/Admin/Admin-ANG/src/assets/fonts/custom/ARIALBD.woff
// module id = ../../../../../src/assets/fonts/custom/ARIALBD.woff
// module chunks = styles